// extracted by mini-css-extract-plugin
module.exports = {"page-wrapper":"app__page-wrapper___289oi","dropdown-wrapper":"app__dropdown-wrapper___7yvH_","middle":"app__middle___16Y5m"};